import React, { useEffect, useRef } from 'react';
import { Button,  Input, Icon, Grid } from 'semantic-ui-react';
import { ITrainingBloc } from '../classes';
import '../style/trainingBloc.css';
import { withTranslation, WithTranslation } from 'react-i18next';
import Hands from '../../../components/Hands/Hands'
import { HangboardDisplay } from '../../../assets/hangboards/hangboardDisplay';
import { useSelector } from 'react-redux';
import { State } from '../../../reducers';
import { useResponsive } from '../../../utils/useResponsive';

interface ITrainingBlocProps extends WithTranslation{
    handleDelete: Function,
    handleRestTime: Function,
    handleDisplayRestTime: Function,
    intensityType: string,
    bloc: ITrainingBloc,
    isAdmin:boolean,
    hangboard: string
}
const TrainingBloc = (props: ITrainingBlocProps) => {
    const { isMobile, isDesktop } = useResponsive();
    const handsConfig = ['left', 'right'];
    const fingers = ['thumb', 'index', 'middle', 'ring', 'pinky'];
    //useEffect(()=>props.bloc.setUsedHolds([]), [props.hangboard]);
    const useDidMountEffect = () => {
        const didMount = useRef(false);

        useEffect(() => {
            if (didMount.current) props.bloc.setUsedHolds([]);
            else didMount.current = true;
        }, [props.hangboard]);
    }
    useDidMountEffect();
    const displayFingers = (hand: string) => {
        const handIndex = hand == 'left' ? 0 : 1;
        const fingersValues = handIndex == 0 ? [...fingers].reverse() : [...fingers];
        return fingers.map((finger, index) => {
            let fingerIndex = fingersValues.findIndex(x => x == finger);
            const isActive = props.bloc.fingers[handIndex][fingerIndex] == 1 ? true : false;
            return <Grid.Row key={index}><Button active={isActive} onClick={() => props.bloc.setFingers(handIndex, fingerIndex)}> {props.t(`fingers.${finger}`)} </Button></Grid.Row>
        }
        );
    }

    useEffect(() => {
            if (props.bloc.intensity > 100 && props.intensityType !== 'absolute') {
                props.bloc.intensity = 100;
                props.bloc.updateBloc(props.bloc);
            }
        }
    );

    const displayHands =
        handsConfig.map((hand, index) =>
        <Grid.Column key={index}>
            <h4 className='handTitle'> {props.t(`fingers.${hand}`)} </h4>
                {displayFingers(hand)}
        </Grid.Column>
        );

    const guideline = () => {
        if (props.isAdmin)
            return (
                <>
                    <p>Guideline</p>
                    <Input id='guideline' placeholder='Enter the guideline' onChange={props.bloc.setGuideline} />
                </>
            )
    }
    const updateUsedHolds=(usedHold: number[])=>{
        props.bloc.setUsedHolds(usedHold as any);
    }
    const hangboardDisplay =()=>{
        console.log(props);
        if(props.hangboard!=='none')
            return(
                <HangboardDisplay name={props.hangboard} usedHolds={props.bloc.usedHolds} callback={updateUsedHolds}/>
            )
        return null;
    }

    const weightUnit = useSelector((state:State) => state.authentication.user.displaySettings.weightUnit);
    const weightFactor = weightUnit == 'kg' ? 1 : 2.2;

    const handleIntensityType = () => {
        switch (props.intensityType) {
            case 'absolute' :
                return <p>{weightUnit}</p>;
            case 'strengthRelative' :
                return <p>{props.t('bloc.strengthRelative')}</p>;
            case 'weightRelative' :
                return <p>{props.t('bloc.weightRelative')}</p>;
            default : return null;
        }
    }

    const setIntensity = (param) => {
        if (props.intensityType == 'absolute') {
                if (param == '+')
                    props.bloc.intensity += (5 / weightFactor);
                else if (param == '-' && props.bloc.intensity > 5)
                    props.bloc.intensity -= (5 / weightFactor);
                else if (typeof param != 'string') {
                    const newValue = param.target.value / weightFactor;
                    (isNaN(newValue)) ? props.bloc.intensity = props.bloc.intensity : props.bloc.intensity = newValue;
                }
                props.bloc.updateBloc(props.bloc);
            }
        else {
            if (param == '+' && props.bloc.intensity <= 95)
                props.bloc.intensity += 5;
            else if (param == '-' && props.bloc.intensity > 5)
                props.bloc.intensity -= 5;
            else if (typeof param != 'string') {
                const newValue = param.target.value;
                (isNaN(newValue)) ? props.bloc.intensity = props.bloc.intensity : props.bloc.intensity = newValue;
                newValue > 100 ? props.bloc.intensity = 100 : props.bloc.intensity = props.bloc.intensity;
            }
            props.bloc.updateBloc(props.bloc);
        }
    }

    return (
        <div className='trainingBloc'>
            {isDesktop && (
                <Button className='delHangBtn' onClick={() => props.handleDelete(props.bloc.id)}>
                    <Icon className='delHangIcon' name='delete' size='large'></Icon>
                    <p>{props.t('bloc.delHang')}</p>
                </Button>
            )}
            {isMobile && (
                <Button className='delHangBtnMobile' onClick={() => props.handleDelete(props.bloc.id)}>
                    <Icon className='delHangIcon' name='delete' size='large'></Icon>
                </Button>
            )}
            <Grid columns={3}>
                <Grid.Row>
                    <Grid.Column className='hangColumn'>
                        <h2 className='repHeader'>{props.t('bloc.hang')}</h2>
                        <div className='infosContainer'>
                            <div className='propertyContainer'>
                                <h4>{props.t('bloc.time')}</h4>
                                <div className='selector'>
                                    <Button className='minusButton' onClick={() => props.bloc.setTime('-')}>
                                        <Icon name='minus' size='large'></Icon>
                                    </Button>
                                    <span className='propertyLayout'>
                                        <h2>{props.bloc.time}</h2>
                                        <p>{props.t('bloc.secs')}</p>
                                    </span>

                                    <Button className='plusButton' onClick={() => props.bloc.setTime('+')}>
                                        <Icon name='plus' size='large'></Icon>
                                    </Button>
                                </div>
                            </div>
                            {guideline()}
                            <div className='propertyContainer'>
                                <h4>{props.t('bloc.intensity')}</h4>
                                <div className='selector'>
                                    <Button className='minusButton' onClick={() => setIntensity('-')}>
                                        <Icon name='minus' size='large'></Icon>
                                    </Button>
                                    <span className='propertyLayout'>
                                        <h2 className='intensityNumber'>
                                            <Input type="text" inputMode="numeric" pattern="[0-9]*" maxLength="3" value={props.intensityType == 'absolute' ? Math.round(props.bloc.intensity * weightFactor) : Math.round(props.bloc.intensity)} onChange={e => setIntensity(e)} transparent />
                                            {handleIntensityType()}
                                            </h2>
                                    </span>
                                    <Button className='plusButton' onClick={() => setIntensity('+')}>
                                        <Icon name='plus' size='large'></Icon>
                                    </Button>
                                </div>
                            </div>

                            <div className='propertyContainer'>
                                <h4>{props.t('bloc.rest')}</h4>
                                <div className='selector'>
                                    <Button className='minusButton' onClick={() => props.handleRestTime(props.bloc.id, '-')}>
                                        <Icon name='minus' size='large'></Icon>
                                    </Button>
                                    <span className='propertyLayout'>
                                        <h2>{props.handleDisplayRestTime(props.bloc.id)}</h2>
                                        <p>{props.t('bloc.secs')}</p>
                                    </span>

                                    <Button className='plusButton' onClick={() => props.handleRestTime(props.bloc.id, '+')}>
                                        <Icon name='plus' size='large'></Icon>
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Grid.Column>
                    <Grid.Column className='fingersColumn'>
                        <div className='fingersContainer'>
                            <h2 className='repHeader'>{props.t('bloc.fingers')}</h2>
                            <Grid columns={2}>
                                <Grid.Row>
                                    {displayHands}
                                </Grid.Row>

                            </Grid>

                        </div>
                    </Grid.Column>
                    {isDesktop && (
                        <Grid.Column className='guidelinesDisplay'>
                            {hangboardDisplay()}
                            <Hands fingers={props.bloc.fingers} fingerClicked={props.bloc.setFingers} />
                        </Grid.Column>
                    )}
                    {isMobile && (
                        <Grid.Column className='guidelinesDisplay' style={{marginTop:'10px!important'}}>
                            {hangboardDisplay()}
                            <Hands fingers={props.bloc.fingers} fingerClicked={props.bloc.setFingers} />
                        </Grid.Column>
                    )}
                    {isDesktop && (
                        <Grid.Column>
                            <div className='hands'>
                                <Hands fingers={props.bloc.fingers} fingerClicked={props.bloc.setFingers}  />
                            </div>
                        </Grid.Column>
                    )}
                </Grid.Row>
            </Grid>
            <div className='repDivider'></div>
        </div>
    )
}


export default withTranslation('exerciseCreator') (TrainingBloc);
